import { Box, CircularProgress, Container } from '@mui/material';
import { useState, useEffect } from 'react';
import { Navigate } from "react-router-dom";
import { useErrorContext } from "../../global/hooks/useErrorContext";
import { useSpecificPlanContext } from '../hooks/useSpecificPlanContext';
import { useIlpContext } from "../hooks/useIlpContext";
import AssessmentView from './AssessmentView';
import { IIndividualLearningPlan } from '../types/interfaces/IIndividualLearningPlan';

export default function SpecificPlanLandingView() {
    const { individualLearningPlan, loadingSpecificPlanCtx, setIndividualLearningPlan } = useSpecificPlanContext();
    const { isAdvisorFlag, isAdminFlag, loadingIlpCtx, setExpandAll, setAreChildrenLoading } = useIlpContext();
    const [topLoadingSpecificPlan, setTopLoadingSpecificPlan] = useState(loadingSpecificPlanCtx || loadingIlpCtx);
    const { error, setError } = useErrorContext();
    const RESIDENT_ROLE = process.env.REACT_APP_NFROLE_RESIDENT;

    useEffect(() => {
        if (!loadingSpecificPlanCtx && !loadingIlpCtx) {
            setTopLoadingSpecificPlan(false);
            setAreChildrenLoading(false);
        }
    }, [loadingSpecificPlanCtx, loadingIlpCtx]);


    if (error) {
        return (
            <Navigate to="/error" />
        );
    }

    if (!loadingSpecificPlanCtx) {
        if (!isAdminFlag && !isAdvisorFlag) {
            setError({ message: process.env.REACT_APP_ILP_INELIGIBLE_ERROR_TEXT!, statusCode: 1 });
            return <Navigate to="/error" />;
        }
        else if (!individualLearningPlan) {
            setError({ message: process.env.REACT_APP_ILP_PLAN_NOT_FOUND!, statusCode: 3 });
            return<Navigate to = "/error" />;
        }
    }

    //Function to handle canceling. Use window x to leave.
    const handleCancel = () => {
    };

    //Function to handle an ilp approving.  Implemented in AssessmentView for advisors only.
    const handleApprove = (savedIlp: IIndividualLearningPlan | null) => {
        setIndividualLearningPlan(savedIlp);
    };

    //Function to handle an ilp updating for a saved plan comment.
    const handleCommentSave = (updateIlp: IIndividualLearningPlan | null) => {
        setIndividualLearningPlan(updateIlp);
    };

    //Function to handleprint view.
    const handlePrint = (printIlp: IIndividualLearningPlan | null) => {
        if (printIlp?.LearnerInfo.Role === RESIDENT_ROLE) {
            setExpandAll(true);
            }
    };

    return (
        <Container>
            {topLoadingSpecificPlan && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: 2 }}>
                <CircularProgress />
            </Box>}
            {!topLoadingSpecificPlan && <AssessmentView plan={individualLearningPlan!} onSave={handleApprove} onCancel={handleCancel} onCommentSave={handleCommentSave} onPrint={handlePrint} />}
            </Container>
    );
}